import { Modal } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

const ContentInfoModal = ({
    open,
    onClose,
}) =>{

return(
    <Modal
  open={open}
  onClose={onClose}
  aria-labelledby="content-info-modal-title"
  className="flex place-content-center items-center fixed animate-fade-slide-down outline-none"
  BackdropProps={{
    style: { pointerEvents: "auto" },
  }}
>
  <div className="bg-white shadow-lg text-[#212529] p-6 rounded-lg animate-fade-slide-down w-max">
    <div className="flex place-content-between border-b pb-5">
      <h2 className="text-xl font-semibold">
        Content Error
      </h2>
      <Tooltip
        title="Close"
        arrow
        placement="top"
        TransitionComponent={Zoom}
        TransitionProps={{ timeout: 300 }}
      >
        <button
          className="text-[#6c757d] text-lg hover:bg-[#edeeef] px-2 rounded-full transition-all ease-in-out duration-500"
          onClick={onClose}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </Tooltip>
    </div>
    <div className="py-6 border-b">
      <p>
        <span>
          <i className="fa-solid fa-triangle-exclamation text-red-400 pe-2"></i>
        </span>
        You’re running low on Quiz Set Count — 1 count covers 3,000 words. Please shorten your document.
      </p>
    </div>
  </div>
</Modal>
)
}

export default ContentInfoModal;